(function () {
  function initGallery(root) {
    var stage = root.querySelector('[data-item-stage]');
    if (!stage) return;

    var frames = Array.prototype.slice.call(stage.querySelectorAll('[data-item-frame]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-item-dots] .discover-item-gallery__dot'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-item-thumb]'));

    function setActive(idx) {
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === idx);
      });
      thumbs.forEach(function (thumb, i) {
        thumb.classList.toggle('is-active', i === idx);
      });
    }

    stage.addEventListener(
      'scroll',
      function () {
        var idx = Math.round(stage.scrollLeft / Math.max(stage.clientWidth, 1));
        setActive(Math.min(idx, frames.length - 1));
      },
      { passive: true }
    );

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        var frame = frames[i];
        if (!frame) return;
        // Desktop stage has overflow hidden; swap by scrolling to offset.
        stage.scrollTo({ left: frame.offsetLeft - stage.offsetLeft, behavior: 'auto' });
        setActive(i);
      });
    });
  }

  function initVariants(root) {
    var form = root.querySelector('[data-item-form]');
    if (!form) return;

    var jsonEl = root.querySelector('[data-item-variants-json]');
    var variants = [];
    if (jsonEl) {
      try {
        variants = JSON.parse(jsonEl.textContent);
      } catch (e) {
        variants = [];
      }
    }

    var idInput = form.querySelector('[data-item-variant-id]');
    var priceEl = root.querySelector('[data-item-price]');
    var compareEl = root.querySelector('[data-item-compare]');
    var atcButton = form.querySelector('[data-item-atc]');
    var atcLabel = form.querySelector('[data-item-atc-label]');
    var soldOutText = (window.theme && theme.variantStrings && theme.variantStrings.soldOut) || 'Sold out';
    var addText = atcLabel ? atcLabel.textContent.trim() : 'Add to Bag';

    function selectedOptions() {
      var opts = [];
      form.querySelectorAll('fieldset[data-option-position]').forEach(function (fieldset) {
        var checked = fieldset.querySelector('input[type="radio"]:checked');
        opts.push(checked ? checked.value : null);
      });
      return opts;
    }

    function findVariant(opts) {
      return variants.find(function (variant) {
        return variant.options.every(function (value, i) {
          return value === opts[i];
        });
      });
    }

    function onChange(event) {
      var fieldset = event.target.closest('fieldset[data-option-position]');
      if (fieldset) {
        var labelValue = fieldset.querySelector('[data-option-value]');
        if (labelValue) labelValue.textContent = event.target.value;
      }

      var variant = findVariant(selectedOptions());
      if (!variant) {
        if (atcButton) {
          atcButton.disabled = true;
          if (atcLabel) atcLabel.textContent = (theme.variantStrings && theme.variantStrings.unavailable) || 'Unavailable';
        }
        return;
      }

      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.innerHTML = variant.price;
      if (compareEl) {
        compareEl.innerHTML = variant.compare_at_price || '';
        compareEl.style.display = variant.compare_at_price ? '' : 'none';
      }
      if (atcButton) {
        atcButton.disabled = !variant.available;
        atcButton.classList.toggle('sold-out', !variant.available);
        if (atcLabel) atcLabel.textContent = variant.available ? addText : soldOutText;
      }
    }

    form.addEventListener('change', function (event) {
      if (event.target.matches('input[type="radio"]')) {
        onChange(event);
      }
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!atcButton || atcButton.disabled || atcButton.classList.contains('loading')) return;

      atcButton.classList.add('loading');
      atcButton.setAttribute('aria-disabled', 'true');

      var formData = new FormData(form);
      formData.delete('item-option-1');
      formData.delete('item-option-2');
      formData.delete('item-option-3');
      formData.append('sections', ['cart-drawer', 'cart-bubble']);
      formData.append('sections_url', window.location.pathname);

      fetch(theme.routes.cart_add_url, {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          Accept: 'application/javascript'
        },
        body: formData
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (response) {
          if (response.status) {
            return;
          }
          renderCartSections(response);
          if (typeof dispatchCustomEvent === 'function') {
            dispatchCustomEvent('cart:item-added', {
              product: response.hasOwnProperty('items') ? response.items[0] : response
            });
          }
        })
        .catch(function (e) {
          console.error(e);
        })
        .finally(function () {
          atcButton.classList.remove('loading');
          atcButton.removeAttribute('aria-disabled');
        });
    });
  }

  function renderCartSections(parsedState) {
    if (!parsedState.sections) return;

    var targets = [
      { id: 'Cart-Drawer', section: 'cart-drawer', selector: '.cart-drawer' },
      { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-item-count' }
    ];

    targets.forEach(function (target) {
      var host = document.getElementById(target.id);
      var markup = parsedState.sections[target.section];
      if (!host || !markup) return;
      var el = host.querySelector(target.selector) || host;
      var doc = new DOMParser().parseFromString(markup, 'text/html');
      var replacement = doc.querySelector(target.selector);
      if (replacement) {
        el.innerHTML = replacement.innerHTML;
      }
    });

    var cartDrawer = document.getElementById('Cart-Drawer');
    if (cartDrawer && typeof OverlayManager !== 'undefined') {
      OverlayManager.open(cartDrawer);
      if (typeof dispatchCustomEvent === 'function') {
        dispatchCustomEvent('cart-drawer:open');
      }
    }
  }

  function initActions(root) {
    var save = root.querySelector('[data-item-save]');
    if (save) {
      save.addEventListener('click', function () {
        save.classList.toggle('is-saved');
        var glyph = save.querySelector('span');
        if (glyph) glyph.textContent = save.classList.contains('is-saved') ? '\u2665' : '\u2661';
      });
    }
  }

  function init(root) {
    initGallery(root);
    initVariants(root);
    initActions(root);
  }

  document.querySelectorAll('[data-discover-item-detail]').forEach(init);
})();
